import type { IconData } from '@stacksjs/iconify-core'

export const headsetF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 10.858v7a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h2a8 8 0 1 0-16 0h2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7c0-5.523 4.477-10 10-10s10 4.477 10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default headsetF
